import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersComponent } from './customers.component';
import { AddCustomerComponent } from './components/add-customer/add-customer.component';
import { EditCustomerComponent } from './components/edit-customer/edit-customer.component';
import { customerByIdResolver } from './resolvers/customer-by-id.resolver';
import { CustomerStatementComponent } from './components/customer-statement/customer-statement.component';
import { hasPermission } from '../shared/guards/permission.guard';
import { PERMISSIONS } from '../../../../common/enums';

const routes: Routes = [
    {
        path: '',
        component: CustomersComponent,
        canActivate: [() => hasPermission(PERMISSIONS.CUSTOMER_READ)],
    },
    {
        path: 'add',
        component: AddCustomerComponent,
        canActivate: [() => hasPermission(PERMISSIONS.CUSTOMER_WRITE)],
    },
    {
        path: ':id',
        component: EditCustomerComponent,
        resolve: {
            customerDetails: customerByIdResolver,
        },
        canActivate: [() => hasPermission(PERMISSIONS.CUSTOMER_WRITE)],
    },
    {
        path: ':id/statement',
        component: CustomerStatementComponent,
        canActivate: [() => hasPermission(PERMISSIONS.CUSTOMER_READ)],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CustomersRoutingModule {}
